import React from "react";
import PropTypes from "prop-types";

const Row = (props) => {
	let className = "u-clear l-grid";
	return (<div style={props.style} className={className}>
		{props.children}
	</div>);
};

Row.propTypes = {
	children: PropTypes.node,
	noSpacing: PropTypes.bool,
	style: PropTypes.object
};

export default Row;
